export default class AddUserRequestListController {
	constructor($scope, $state, notification, UserRequestService, DomainPortailService, ModalService) {
		this.$scope = $scope;
		this.$state = $state;
		this.notification = notification;
		this.UserRequestService = UserRequestService;
		this.DomainPortailService = DomainPortailService;
		this.ModalService = ModalService;
	}
	selectedReq = null;
	domaines = [];
	sites = [
		{
			id: 1,
			libelle: 'site 1'
		},
		{
			id: 2,
			libelle: 'site 2'
		}
	];
	selectedSite;

	async $onInit() {
		this.loadAll();
	}

	setSelectedFiltre() {
		console.log(this.selectedSite);
	}

	async loadAll() {
		try {
			this.addRequest = (await this.UserRequestService.getAllAddUserRequest()).data || [];
			this.domaines = (await this.DomainPortailService.getAll()).data || [];

			this.addRequest.forEach(async (addReq) => {
				if (addReq.societeCommercialeId) {
					addReq.societeCom = await this.UserRequestService.getSocieteById(addReq.societeCommercialeId);
				}
			});
			console.log(this.addRequest);
		} catch (error) {
			this.notification.error(error.data.message);
		}
	}

	async closeReq(request, validate) {
		request.loading = true;
		request.status = validate ? 1 : 2;
		try {
			if (!request.fromLogin) {
				console.log(request);
				const res = await this.UserRequestService.updateAddUserRequest(request);
				if (validate) {
					this.notification.success('PORTAIL.USER.UPDATE_REQUEST_VALID');
				} else {
					this.notification.success('PORTAIL.USER.UPDATE_REQUEST_REFUS');
				}

				if (res.data == 'Email Error') {
					this.notification.warning('PORTAIL.USER.UPDATE_REQUEST_MAIL_ERROR');
				} else {
					this.notification.success('PORTAIL.USER.UPDATE_REQUEST_MAIL');
				}
				this.UserRequestService.loadAll();
				this.loadAll();
				const idx = this.addRequest.findIndex((x) => x.id === request.id);
				this.addRequest.splice(idx, 1);
			} else {
				if (validate) {
					//Open modal
					const modalInstance = this.ModalService.open({
						component: 'acceptationUserPortailModal',
						animation: true,
						size: 'lg',
						backdrop: true,
						resolve: {
							selectedReq: () => request
						},
						windowClass: 'modern-modal-responsive'
					});
					modalInstance.result.then(async () => {
						try {
							await this.UserRequestService.updateAddUserRequest(request);
							this.UserRequestService.loadAll();
							this.loadAll();
							const idx = this.addRequest.findIndex((x) => x.id === request.id);
							this.addRequest.splice(idx, 1);
							this.notification.success('PORTAIL.USER.UPDATE_REQUEST_VALID');
						} catch (error) {
							console.log('🔥: ConfigurationEmailListController -> getModalConfig -> error', error);
							this.notification.error(`PORTAIL.USER.${error.data.message}`);
						}
					});
				} else {
					await this.UserRequestService.updateAddUserRequest(request);
					console.log('totototo');
					this.loadAll();
					const idx = this.addRequest.findIndex((x) => x.id === request.id);
					this.addRequest.splice(idx, 1);
					this.notification.success('PORTAIL.USER.UPDATE_REQUEST_REFUS');
				}
			}
			this.UserRequestService.loadAll();
		} catch (error) {
			this.notification.error(error.data.message);
		}
	}

	selectReq(req) {
		this.selectedReq = req;
		this.selectedReq.rights = this.mapDomaines(this.selectedReq.rights);
		console.log(this.selectedReq);
	}

	mapDomaines(listAccess) {
		this.domaines.items.forEach((domaine) => {
			const found = listAccess.some((access) => access.domainId === domaine.id);

			if (!found) {
				listAccess.push({
					domainId: domaine.id,
					domainNom: domaine.libelle,
					domainCode: domaine.code,
					accessLevel: 0,
					requestId: null
				});
			}
		});
		return listAccess;
	}
}

AddUserRequestListController.$inject = ['$scope', '$state', 'notification', 'UserRequestService', 'DomainPortailService', 'ModalService'];
